import React from 'react';
import { NavLink } from 'react-router-dom';
import { CalendarDaysIcon, LayersIcon, LayoutDashboardIcon, PackageIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import { planMeta } from '../data/plan';
const NAV = [{
  to: '/',
  label: 'Overview',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/calendar',
  label: 'Weekly calendar',
  icon: CalendarDaysIcon
}, {
  to: '/products',
  label: 'Products & risk',
  icon: PackageIcon
}, {
  to: '/production',
  label: 'Production',
  icon: LayersIcon
}];
export function Sidebar() {
  const {
    theme
  } = useTheme();
  return <nav aria-label="Sections" className="flex shrink-0 gap-2 overflow-x-auto border-b border-ink-700 bg-ink-900 px-4 py-3 lg:w-60 lg:flex-col lg:gap-1 lg:overflow-visible lg:border-b-0 lg:border-r lg:px-3 lg:py-6" data-id="element-83" data-mp="3lcbbouuarc7e">
      <div className="flex shrink-0 items-center px-2 lg:block lg:pb-6" data-id="element-84" data-mp="3cbmvpulcf1rv">
        <img src="https://cdn.magicpatterns.com/uploads/e7dX1XaU16LT62JhgqNWnJ/Schermafbeelding_2026-07-29_174752.png" alt="BitterBrains" className={`h-7 w-auto object-contain ${theme === 'dark' ? 'rounded-md bg-white px-2 py-1' : ''}`} data-id="element-85" data-mp="37cthu12598r6" />
        <p className="hidden font-mono text-[10px] uppercase tracking-[0.16em] text-faint lg:mt-3 lg:block" data-id="element-86" data-mp="1cz8vq0kkjzw8">
          Content Ops · {planMeta.window}
        </p>
      </div>

      {NAV.map(({
      to,
      label,
      icon: Icon,
      end
    }) => <NavLink key={to} to={to} end={end} className={({
      isActive
    }) => `flex shrink-0 items-center gap-2.5 rounded-lg px-3 py-2 text-[13px] transition-colors ${isActive ? 'bg-ink-800 text-chalk' : 'text-mute hover:bg-ink-850 hover:text-chalk'}`} data-id="element-87" data-mp="24r81feniih22">
          <Icon className="h-4 w-4" aria-hidden="true" data-id="element-88" data-mp="20qedwmdzf49p" />
          {label}
        </NavLink>)}

      <div className="mt-auto hidden px-3 lg:block" data-id="element-89" data-mp="kco552bx3rtq">
        <p className="font-mono text-[10px] uppercase tracking-[0.16em] text-faint" data-id="element-90" data-mp="pa66a6jp12r6">Baseline cadence</p>
        <p className="mt-2 text-[11px] leading-relaxed text-mute" data-id="element-91" data-mp="2qx93nquq77c5">{planMeta.cadence}</p>
      </div>
    </nav>;
}